import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import styles from "./addform.module.css";
import { X } from "react-feather";
import { useAuth0 } from "@auth0/auth0-react";
import { useState, useEffect } from "react";
import axios from "axios";
import { Controller, useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { toast } from "react-smart-toaster";

const schema = yup.object().shape({
  property_id: yup.string().required("This field is Required"),
  apt_id: yup.string(),
  tenant_id: yup.string(),
  tenant_info_id: yup.string().required("This field is Required"),
  title: yup.string().required("This field is Required"),
  type: yup.string().required("This field is Required"),
  weight: yup.string().required("This field is Required"),
  color: yup.string().required("This field is Required"),
});

const PetEditForm = ({
  setAddModalOpen,
  setLoading,
  setSnackbarMsg,
  setSnackbarOpen,
  onSubmitLocal,
  editData,
}) => {
  const { getAccessTokenSilently } = useAuth0();
  const [propertyList, setPropertyList] = useState([]);
  const [tenantList, setTenantList] = useState([]);
  const [uploadedImage, setUploadedImage] = useState({ file: null, path: "" });
  const [prevImagePath, setPrevImagePath] = useState("");

  const { register, handleSubmit, control, errors, setValue } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    defaultValues: {
      property_id: "",
      apt_id: "",
      tenant_id: "",
      tenant_info_id: "",
    },
  });

  useEffect(() => {
    async function getProperties() {
      const token = await getAccessTokenSilently({
        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
      });

      axios(process.env.REACT_APP_TENANT_API_URL + "v1/property-list2", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => {
          setPropertyList(response.data.data);
        })
        .catch((error) => {});
    }
    getProperties();
  }, [getAccessTokenSilently]);

  useEffect(() => {
    if (editData) {
      setValue("property_id", editData?.property_id);
      setValue("apt_id", editData?.apt_id);
      setValue("tenant_id", editData?.tenant_id);
      setValue("tenant_info_id", editData?.tenant_info_id);
      setValue("title", editData?.title);
      setValue("type", editData?.type);
      setValue("weight", editData?.weight);
      setValue("color", editData?.color);

      setPrevImagePath(editData?.image_path);

      if (editData?.property_id) {
        let selectedProperty = propertyList?.filter(
          (i) => i?.id === editData?.property_id
        );
        if (selectedProperty?.length > 0) {
          selectedProperty = selectedProperty[0];

          let tenantList = selectedProperty?.tenants2?.map((i) => {
            return {
              id: i?.id,
              tenant_id: i?.tenant_id,
              name: i?.first_name + " " + i?.last_name,
              apt_id: i?.apt_id,
            };
          });

          setTenantList(tenantList);
        }
      }
    }
  }, [editData, setValue, propertyList]);

  const fileHandler = (e) => {
    var validExtensions = ["jpg", "jpeg", "png", "svg"];
    var fileName = e.target.files[0].name;
    var fileNameExt = fileName.substr(fileName.lastIndexOf(".") + 1);
    if (validExtensions.indexOf(fileNameExt.toLowerCase()) === -1) {
      toast.error("File type is not allowed");
    } else if (e.target.files[0].size > 5242880) {
      toast.error("Image size should not be greater than 5 mb.");
    } else {
      for (let n = 0; n < e.target.files.length; n++) {
        let file = e.target.files[n];
        setUploadedImage({ file: file, path: URL.createObjectURL(file) });
      }
    }
  };

  const onSubmit = async (data) => {
    let formData = new FormData();

    formData.append("title", data["title"]);
    formData.append("type", data["type"]);
    formData.append("weight", data["weight"]);
    formData.append("color", data["color"]);
    formData.append("property_id", data["property_id"]);
    formData.append("apt_id", data["apt_id"]);
    formData.append("tenant_id", data["tenant_id"]);
    formData.append("tenant_info_id", data["tenant_info_id"]);

    formData.append("imagepath", prevImagePath);

    if (uploadedImage?.file) {
      formData.append("image", uploadedImage?.file);
    }

    setLoading(true);
    setAddModalOpen(false);

    const token = await getAccessTokenSilently({
      audience: process.env.REACT_APP_AUTH0_AUDIENCE,
    });

    return axios
      .post(
        process.env.REACT_APP_TENANT_API_URL + "v1/pets/" + editData?.id,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        setLoading(false);

        setSnackbarOpen(true);
        setSnackbarMsg(response.data.message);

        onSubmitLocal(response.data.data);
      })
      .catch((error) => {
        if (typeof error.response !== "undefined")
          toast.error(error.response.data.message);
        setLoading(false);
      });
  };

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <input type="hidden" ref={register} name="apt_id" />
        <input type="hidden" ref={register} name="tenant_id" />
        <div className={`${styles.ReqAddRow}`}>
          <div className={`${styles.ReqAddFormSec}`}>
            <div className={`${styles.FormSecRow}`}>
              <div className={`${styles.FormHalfSec}`}>
                <div className={`${styles.FormSec}`}>
                  <div className={`${styles.FormGroupFull} FormGroup`}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Property*
                      </InputLabel>
                      <Controller
                        name="property_id"
                        control={control}
                        render={(field) => (
                          <Select
                            {...field}
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label="Property"
                            onChange={(e) => {
                              field.onChange(e);

                              if (e.target.value) {
                                let selectedProperty = propertyList?.filter(
                                  (i) => i?.id === e.target.value
                                );
                                if (selectedProperty?.length > 0) {
                                  selectedProperty = selectedProperty[0];
                                  let tenantList = selectedProperty?.tenants2?.map(
                                    (i) => {
                                      return {
                                        id: i?.id,
                                        tenant_id: i?.tenant_id,
                                        name:
                                          i?.first_name + " " + i?.last_name,
                                        apt_id: i?.apt_id,
                                      };
                                    }
                                  );
                                  setTenantList(tenantList);
                                }
                              } else {
                                setTenantList([]);
                              }

                              setValue("tenant_info_id", "");
                            }}
                          >
                            {propertyList?.map((item) => {
                              return (
                                <MenuItem
                                  value={item.id}
                                  disabled={item?.tenants2?.length === 0}
                                >
                                  {item.name}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        )}
                      />
                    </FormControl>
                    {errors.property_id && (
                      <p className={`${styles.ErrorM}`}>
                        {errors?.property_id?.message}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className={`${styles.FormHalfSec}`}>
                <div className={`${styles.FormSec}`}>
                  <div className={`${styles.FormGroupFull} FormGroup`}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Tenant*
                      </InputLabel>
                      <Controller
                        name="tenant_info_id"
                        control={control}
                        render={(field) => (
                          <Select
                            {...field}
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label="Tenant"
                            onChange={(e) => {
                              field.onChange(e);

                              if (e.target.value) {
                                let selectedTenant = tenantList?.filter(
                                  (i) => i?.id === e.target.value
                                );
                                if (selectedTenant?.length > 0) {
                                  selectedTenant = selectedTenant[0];
                                  setValue("apt_id", selectedTenant?.apt_id);
                                  setValue(
                                    "tenant_id",
                                    selectedTenant?.tenant_id?.toString()
                                  );
                                }
                              }
                            }}
                          >
                            {tenantList.length === 0 && (
                              <MenuItem disabled value={""}>
                                Select Property First
                              </MenuItem>
                            )}
                            {tenantList?.map((item) => {
                              return (
                                <MenuItem value={item.id}>{item.name}</MenuItem>
                              );
                            })}
                          </Select>
                        )}
                      />
                    </FormControl>
                    {errors.property_id && (
                      <p className={`${styles.ErrorM}`}>
                        {errors?.property_id?.message}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className={`${styles.FormSecRow}`}>
              <div className={`${styles.FormHalfSec}`}>
                <div className={`${styles.FormSec}`}>
                  <div className={`${styles.FormGroupFull} FormGroup`}>
                    <Controller
                      name={`title`}
                      control={control}
                      render={(field) => (
                        <TextField
                          {...field}
                          id="outlined-basic"
                          label="Pet Name*"
                          variant="outlined"
                        />
                      )}
                    />
                    {errors.title && (
                      <p className={`${styles.ErrorM}`}>
                        {errors?.title?.message}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className={`${styles.FormHalfSec}`}>
                <div className={`${styles.FormSec}`}>
                  <div className={`${styles.FormGroupFull} FormGroup`}>
                    <Controller
                      name={`type`}
                      control={control}
                      render={(field) => (
                        <TextField
                          {...field}
                          id="outlined-basic"
                          label="Type*"
                          variant="outlined"
                        />
                      )}
                    />
                    {errors.type && (
                      <p className={`${styles.ErrorM}`}>
                        {errors?.type?.message}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className={`${styles.FormSecRow}`}>
              <div className={`${styles.FormHalfSec}`}>
                <div className={`${styles.FormSec}`}>
                  <div className={`${styles.FormGroupFull} FormGroup`}>
                    <Controller
                      name={`weight`}
                      control={control}
                      render={(field) => (
                        <TextField
                          {...field}
                          id="outlined-basic"
                          label="Weight*"
                          variant="outlined"
                        />
                      )}
                    />
                    {errors.weight && (
                      <p className={`${styles.ErrorM}`}>
                        {errors?.weight?.message}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className={`${styles.FormHalfSec}`}>
                <div className={`${styles.FormSec}`}>
                  <div className={`${styles.FormGroupFull} FormGroup`}>
                    <Controller
                      name={`color`}
                      control={control}
                      render={(field) => (
                        <TextField
                          {...field}
                          id="outlined-basic"
                          label="Color*"
                          variant="outlined"
                        />
                      )}
                    />
                    {errors.color && (
                      <p className={`${styles.ErrorM}`}>
                        {errors?.color?.message}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className={`${styles.FormIMGSec} ${styles.FileUploadSmall}`}>
              <div className={`${styles.FileIMGDiv}`}>
                {!uploadedImage?.file && prevImagePath === "" && (
                  <div className={`${styles.FileUpDuBUDiv}`}>
                    <label
                      for="file-upload"
                      className={`${styles.UploadLabel}`}
                    >
                      <span>
                        <div className={`${styles.UpIcon}`}>
                          <img src="/static/img/upload-floor.svg" alt="" />
                        </div>
                        <div>
                          <p>Upload Photo</p>
                          <p className={`${styles.UploadText}`}>
                            File size upto 5 MB <br /> JPEG, JPG, PNG only
                          </p>
                        </div>
                      </span>
                    </label>
                    <input
                      id="file-upload"
                      type="file"
                      onChange={fileHandler}
                      accept=".jpg,.png,.jpeg,.svg"
                      inputProps={{ accept: "image/*" }}
                    />
                  </div>
                )}
                {prevImagePath !== "" && (
                  <div className={`${styles.UpIMGSec}`}>
                    <div className={`${styles.ImgFile}`}>
                      <img src={prevImagePath} alt="" />
                      <button onClick={(e) => setPrevImagePath("")}>
                        {" "}
                        <X />{" "}
                      </button>
                    </div>
                  </div>
                )}
                {uploadedImage?.file && (
                  <div className={`${styles.UpIMGSec}`}>
                    <div className={`${styles.ImgFile}`}>
                      <img src={uploadedImage?.path} alt="" />
                      <button
                        onClick={(e) =>
                          setUploadedImage({ file: null, path: "" })
                        }
                      >
                        {" "}
                        <X />{" "}
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className={`${styles.ButtonAction}`}>
          <Button
            onClick={(e) => setAddModalOpen(false)}
            className="CancelPopupBU"
          >
            Cancel
          </Button>
          <Button type="submit" className="SubmitPopupBU">
            Update
          </Button>
        </div>
      </form>
    </div>
  );
};

export default PetEditForm;
